import { render, staticRenderFns } from "./Recycled.vue?vue&type=template&id=2f521b7c"
import script from "./Recycled.vue?vue&type=script&lang=js"
export * from "./Recycled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports